import { useMemo } from "react";
import type { HomePageViewModel } from "src/http/types";

export const useAddRecentlyViewedToModel = (model: HomePageViewModel) => {
  const showAddRecentlyViewedToModel =
    !!model.recentlyViewedItems?.output?.length && model.recentlyViewedItems.output.length > 0;

  const recentlyViewedItems = useMemo(() => {
    if (showAddRecentlyViewedToModel) {
      return {
        ...model.recentlyViewedItems,
        items: model.recentlyViewedItems?.output,
      };
    }
    return undefined;
  }, [model.recentlyViewedItems, showAddRecentlyViewedToModel]);

  const recentlyViewedTimeWindow = useMemo(() => {
    if (showAddRecentlyViewedToModel) {
      return model.recentlyViewedItems?.dateRange;
    }
    return undefined;
  }, [model.recentlyViewedItems, showAddRecentlyViewedToModel]);

  return {
    recentlyViewedItems,
    showAddRecentlyViewedToModel,
    recentlyViewedTimeWindow,
  };
};
